import { CircleCheck, TriangleAlert } from "lucide-react";
import { Button } from "@chakra-ui/react";

import { useInvoiceUpdate } from "../../../hooks/useInvoiceUpdate";
import { InvoiceDetailSchema, InvoiceStatus } from "../../../generated";
import { Camelize } from "camelize-ts";

export const InvoiceStatusButton = ({
  invoice,
}: {
  invoice: Camelize<InvoiceDetailSchema>;
}) => {
  const invoiceUpdateMutation = useInvoiceUpdate();

  if (invoice.status === InvoiceStatus.PAID) {
    return (
      <Button
        width={150}
        onClick={() =>
          invoiceUpdateMutation.mutate({
            invoiceUuid: invoice.uuid,
            requestBody: {
              status: InvoiceStatus.REGISTERED,
            },
          })
        }
        colorPalette="yellow"
      >
        Ikke betalt <TriangleAlert />
      </Button>
    );
  }

  return (
    <Button
      width={150}
      onClick={() =>
        invoiceUpdateMutation.mutate({
          invoiceUuid: invoice.uuid,
          requestBody: {
            status: InvoiceStatus.PAID,
          },
        })
      }
      colorPalette="green"
      disabled={invoice.status !== InvoiceStatus.REGISTERED}
    >
      Sett til betalt <CircleCheck />
    </Button>
  );
};
